// accordions
const accordionGroups = document.querySelectorAll(".accordion-group");
//console.log('accordiongroups',accordionGroups)
accordionGroups.forEach((group) => {
  group.querySelectorAll(".accordion-item").forEach((child, i) => {
    child
      .querySelector(".accordion-toggle")
      .addEventListener("click", function (e) {
        //console.log('clicked accordion toggle')
        child.classList.toggle("active");
        // child.querySelector('.accordion-content').computedStyleMap.height = child.classList.contains('active') ? child.querySelector('.accordion-content').scrollHeight + 'px' : '0px'
        if (child.classList.contains("active")) {
          child.querySelector(".accordion-content").style.height =
            child.querySelector(".accordion-content").scrollHeight + "px";
        } else {
          child.querySelector(".accordion-content").style.height = "0px";
        }
        // close others
        group
          .querySelectorAll(".accordion-item")
          .forEach((sibling, j) => {
            if (i !== j) {
              sibling.querySelector(".accordion-content").style.height =
                "0px";
              sibling.classList.remove("active");
            }
          });
      });
  });

  window.addEventListener('resize', function() {

      group.querySelectorAll(".accordion-item").forEach((child, i) => {
        child.classList.remove("active");
      });

  });
});